import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../common/Spinner";
import * as authSelectors from "./../auth/authSelectors";
import * as shopActions from "./shopActions";
import * as shopSelectors from "./shopSelectors";
import { ShopListRow } from "./ShopListRow";
import { routes } from "../../appRoutingHelpers";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { Table } from "../../components/table-components/Table";
import { TableRowHeader } from "../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../components/table-components/TableCellHeaderText";
import { ButtonInternalLink } from "../../components/NewButtons";

interface Props {}

export const ShopList: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const shops = useSelector(shopSelectors.shopList);
  const isLoadingShops = useSelector(shopSelectors.isLoadingShopList);
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);

  React.useEffect(() => {
    dispatch(shopActions.getShopListAction(organization));
  }, [dispatch, organization]);

  return (
    <div className="container mt-7">
      <div className="row row-cards row-deck">
        <div className="col-12">
          <div className="card">
            <div className="card-header border-bottom-0 mt-4 mb-4 justify-content-between">
              <StyledText
                color={colors.textPrimary}
                className="bodyHeaderOneSemi card-title"
              >
                Shop list
              </StyledText>
              <ButtonInternalLink to={routes.venueList(organization) + "/new"}>
                Create new shop
              </ButtonInternalLink>
            </div>
            <div className="pl-5 pr-5">
              <Table>
                <thead>
                  <TableRowHeader>
                    <TableCellHeaderText className="pl-3">
                      Name
                    </TableCellHeaderText>
                    <TableCellHeaderText>Title</TableCellHeaderText>
                    <TableCellHeaderText> </TableCellHeaderText>
                  </TableRowHeader>
                </thead>
                <tbody>
                  {shops?.map((shop) => {
                    return <ShopListRow key={shop.id} shop={shop} />;
                  })}
                </tbody>
              </Table>
            </div>
            <div className="card-footer text-center mr-5 ml-5 px-0">
              {isLoadingShops && <Spinner />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
